/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-information-card.html";

export class NsInformationCard extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get is() {
    return "ns-information-card";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      image: String,
      imageAltText: String,
      ctaLink: String
    };
  }
}

customElements.define(NsInformationCard.is, NsInformationCard);
